import { render, staticRenderFns } from "./retrievalCard.vue?vue&type=template&id=2e787775&scoped=true&"
import script from "./retrievalCard.vue?vue&type=script&lang=js&"
export * from "./retrievalCard.vue?vue&type=script&lang=js&"
import style0 from "./retrievalCard.vue?vue&type=style&index=0&id=2e787775&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e787775",
  null
  
)

export default component.exports